module.exports = __webpack_public_path__ + "img/promoted.a45cb7a2.svg";